import { LocationStrategy, PathLocationStrategy } from '@angular/common';
import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { Router } from '@angular/router';
import { SiteService } from '../../services';
@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
    constructor(private injector: Injector) { }
    handleError(error) {
        const router = this.injector.get(Router);

        var data = localStorage.getItem('currentUser');

        if (this.IsJsonString(data) && data != null || data != undefined) {
            var token = JSON.parse(localStorage.getItem('currentUser')).Token;

            if (!token) {
                localStorage.clear();
                router.navigate([`/login`]);
            }
        } else {
            localStorage.clear();
            router.navigate([`/login`]);
        }
        throw (error)
    }

    IsJsonString(str) {
        try {
            JSON.parse(str);
        } catch (e) {
            return false;
        }
        return true;
    }

}



// WEBPACK FOOTER //
// ./src/app/shared/errorhandler/GlobalErrorHandler.ts